<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { goBackPath } from "@/utils/base";
export default {
  name: "App",
  mounted() {
    if (getToken() && !this.$route.meta.skipAutoRedirect) {
      // 已存在token, 跳回上个页面
      goBackPath();
    }
  },
};
</script>
